export const firebaseConfig = {
  apiKey: "AIzaSyDr5n-LKnmavyGosqK9FjJadkHM4CAG9Og",
  authDomain: "hmonitor-57097.firebaseapp.com",
  //authDomain: "habits-monitor.vercel.app/",
  projectId: "hmonitor-57097",
  storageBucket: "hmonitor-57097.appspot.com",
  messagingSenderId: "1038874301708",
  appId: "1:1038874301708:web:213fe7a3fd63e4a93da529",
  measurementId: "G-THD2K9C2R0"
}
